import { getLinkSessionId } from '@/graphql/execute';
import { UserOrganizationRole } from '@/graphql/graphql';
import { useOrganizations } from '@/hooks/useOrganizations';

/**
 * Who may see launcher entry points at all (spec D6.1 / GIS-284): editors,
 * never on a shared link — shared links bypass auth and these runs cost real
 * compute. The availability resolver hides every item for them too; this is
 * the guard for the buttons themselves.
 */
export function useCanRunAnalyses(): boolean {
  const { hasRole } = useOrganizations();
  return hasRole(UserOrganizationRole.Editor) && !getLinkSessionId();
}
